import Alert from 'components/alert';

const OneOrManyErrors = ({
  errors,
  heading = 'A few issues came up that need to be fixed.',
}: {
  errors: string[];
  heading?: string;
}) => {
  return (
    <>
      {errors.length === 1 && errors[0]}
      {errors.length > 1 && (
        <>
          {heading}
          <ul>
            {errors.map(error => (
              <li key={error}>{error}</li>
            ))}
          </ul>
        </>
      )}
    </>
  );
};

export const ErrorBox = ({ errors }: { errors: string[] }) => (
  <Alert
    px={2}
    pb={2}
    pt={2}
    mt={2}
    mb={4}
    fontSize="regular"
    variant="error"
    lineHeight={1.3}
  >
    <OneOrManyErrors errors={errors} />
  </Alert>
);
